require(['jquery'], function ($) {

    if ($('.xm-grid-category').length) $('html').addClass('page-type-category');

    const sidebar = $('.category-sidebar');
    const main = $('.category-main');

    /// Full Width Main Container if no Sidebar ///
    if (sidebar.text().trim() === "" || $(window).innerWidth() < 960) {
        main.addClass('grid12-12');
        main.removeClass('grid12-9 grid-col2-main');
    }

    /// Add Class to Stock Status Column on Custom Category Grid ///
    $('.products-list .stock-status-box').parent().addClass('stock-status-column');
    
    //Set the height for each element and remove the flickering on hover over
    $('.category-products-grid .item').mouseover(function(){
    if (!$('head style[data-item_hover]').length) {
    	const style = $(this).attr('style');
    
        let styleObj = style.split(";").reduce(function(obj, str, index) {
          let strParts = str.split(":");
          if (strParts[0] && strParts[1]) { //<-- Make sure the key & value are not undefined
            obj[strParts[0].replace(/\s+/g, '')] = strParts[1].trim(); //<-- Get rid of extra spaces at beginning of value strings
          }
          return obj;
        }, {});
        
      
      	$('head style:not([type])').text(function(){
          return $(this).text() + ' .category-products-grid.hover-effect .item:hover { height: ' + styleObj.height + ' !important; }';
        });
      
        $('head style:not([type])').attr('data-item_hover', 'active');
 	}
  });
});